$ = jQuery;
var bundleBuilder = {};
var win = $(window);
var doc = $(document);

bundleBuilder = {
  defaults: {
		bundleItems: {'required-items': [], 'separate-items': [], 'optional-items': []},
		totalBundlePrice: '',
    addBundleItemsObj: {},
    bedSetObj: {},
    bedSetBreakDown: false,
    isBedSet: false,
    initialUrl: window.location.href,
    image3dPreview: $("#product-customiser-viewer"),
    roundOffToggle: $('#ProductBundleBuilder3d').attr('data-roundoff'),
    preOrderMessage: '',
    preOrderIntValues: [],
    monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
    currencyLabel: '',
    applySizeAllOnce: true,
    overRideSizeOffset: false,
    imageBundleConfig: {
      0: {
        "fabricSection": "duvet-cover_1_1",
        "selectedOption": "white"
      },
      1: {
        "fabricSection": "fitted-sheet_1_1",
        "selectedOption": "white"
      },
      2: {
        "fabricSection": "standard-pillowcase_1_2_0",
        "selectedOption": "white"
      },
      3: {
        "fabricSection": "flat-sheet_1_1",
        "selectedOption": "white"
      },
      4: {
        "fabricSection": "standard-pillowcase_2_2_0",
        "selectedOption": "white"
      }
    },
    image3dVarHolder: {
      0: {
        "fabricSection": "duvet-cover_1_1",
        "selectedOption": "white"
      },
      1: {
        "fabricSection": "fitted-sheet_1_1",
        "selectedOption": "white"
      },
      2: {
        "fabricSection": "standard-pillowcase_1_2_0",
        "selectedOption": "white"
      },
      3: {
        "fabricSection": "flat-sheet_1_1",
        "selectedOption": "white"
      },
      4: {
        "fabricSection": "standard-pillowcase_2_2_0",
        "selectedOption": "white"
      },
      5: {
        "fabricSection": "fitted-sheet_2_2",
        "selectedOption": "white"
      },
      6: {
        "fabricSection": "standard-pillowcase_3_3_0",
        "selectedOption": "white"
      },
      7: {
        "fabricSection": "candle",
        "selectedOption": "white"
      }
    },
    imageBundleVars: {
      'fittedSheetCount': 1,
      'flatSheetCount': 1,
      'sPillowCount': 1,
      'ePillowCount': 0,
      'sheetSeparatesType': 'flat-sheet',
      'sheetOptionalType': 'fitted-sheet',
      'sheetSeparatesIndex': 1,
      'sheetOptionalIndex': 2,
      'pillowSeparatesSize': 'standard-size',
      'pillowSeparatesIndex': 2,
      'pillowOptionalSize': 'standard-size',
      'pillowOptionalIndex': 3,
      'incOptionalSheet': false,
      'incOptionalPillow': false,
      'incOptionalCandle': false,
    }
  },
  onInit: function() {
    var vm = this;
  },
  onReady: function(e) {
    var vm = this;
    // ga('send', 'event', 'BYOB', 'render_type', 'v2');
    var storeLocation = $('body').attr('data-store-location');
    vm.pushEvent('BYOBEvent', 'v2');
    vm.onResize();
    // vm.introFunctions();
    vm.initiateBundle3dImage();
    vm.bundleMobileNav();
    vm.bundleBuilderTabs();
    vm.bundleOptionSelect();
    // vm.bundleOptionalItemSelect();
    // vm.applySizeToAll();
    vm.optionalCheckbox();
    vm.bundlePreview();

    $('.bundle-review-popup .preview-wrapper a.btn, .bundle-review-popup .mobile-atc-wrapper a.btn.cta-checkout, .mobile-checkout .cta-checkout-wrapper .cta-addtocart-bundle').on('click', function(e) {
			e.preventDefault();
      if (vm.defaults.bundleItems['required-items'].length == 3 && vm.defaults.bundleItems['separate-items'].length == 2 ) {
        $(this).addClass('loading');
        vm.ajaxAddBundleToCart();
      }
		});
    if (storeLocation == 'US') {
      var hideHybridSizes = ['twin-twin-xl', 'full-queen', 'king-cali-king'];
      $.each(hideHybridSizes, function(i, v) {
        $(`.product-wrapper[data-itemtype="sheet"] .bundle-size-wrapper li a[data-value="${v}"]`).parent().hide();
        $(`.product-wrapper[data-itemtype="sheet-optional"] .bundle-size-wrapper li a[data-value="${v}"]`).parent().hide();
      });
    }
  },
  onLoad: function(e) {
    $('.product-info .btn-getstarted').text('Get Started');
    $('.product-info .btn-getstarted').removeClass('loading');
  },
  onResize: function(e) {
    var vm = this;
    vm.bundleItemsCarousel();
  },
  introFunctions: function() {
    $('.bundle-details .btn-getstarted').on('click', function(e) {
      e.preventDefault();
      $('body').addClass('bundle-started');
      $('.bundle-details .product-info').addClass('hide');
      $('.bundle-main-frame').addClass('started');
    });

    $('.bundle-main-frame .btn-close-builder').on('click', function(e) {
      e.preventDefault();
      $('body').removeClass('bundle-started');
      $('.bundle-details .product-info').removeClass('hide');
      $('.bundle-main-frame').removeClass('started');
    });

    $('.bundle-details .cta-readmore').on('click', function(e) {
      e.preventDefault();
      if ($(this).hasClass('expanded')) {
        $(this).text('Read More +');
        $(this).parent().find('.main-desc').removeClass('expanded');
        $(this).removeClass('expanded');
      } else {
        $(this).addClass('expanded');
        $(this).parent().find('.main-desc').addClass('expanded');
        $(this).text('Read Less -');
      }
    })
  },
  bundleBuilderTabs: function() {
    var vm = this, el = vm.defaults;
    $('.bundle-tab-control .tab-control, .tab-c-mobile .tab-control').on('mousedown', function(e) {
      e.preventDefault();
      $('body').removeClass('bundle-mobile-expand');
      var tabId = $(this).attr('data-tab');
      var currentActiveTabContent = $('.bundle-tab-content .tab-content.active');
      var currentTabInnerIndex = $('.tab-c-mobile .tab-control.active').attr('data-mobtab');
      var currentProductType = currentActiveTabContent.find('.product-wrapper').attr('data-itemtype');
      var currentProductCategory = currentActiveTabContent.find('.product-wrapper').attr('data-itemcategory');
      var currentProductCount = currentActiveTabContent.find('.product-wrapper:not([data-itemcategory="optional"])');
      var currentProductFilled = currentActiveTabContent.find('.product-wrapper.filled:not([data-itemcategory="optional"])');
      if (currentProductType == 'duvet') {
        vm.applySizeToAll();
      } else {
        el.overRideSizeOffset = true;
      }
      if (currentProductCount.length == currentProductFilled.length && currentProductCategory != 'optional') {
        var currentTabIndex = currentActiveTabContent.attr('data-tab');
        $(`.bundle-tab-control .tab-control[data-tab="${currentTabIndex}"]`).addClass('complete').removeClass('not-complete');
      } else if (currentProductCount.length != currentProductFilled.length && currentProductCategory != 'optional') {
        var currentTabIndex = currentActiveTabContent.attr('data-tab');
        $(`.bundle-tab-control .tab-control[data-tab="${currentTabIndex}"]`).addClass('not-complete').removeClass('complete');
      } else if (currentProductCategory == 'optional') {
        var currentTabIndex = currentActiveTabContent.attr('data-tab');
        var includedOptionalCount = currentActiveTabContent.find('.product-wrapper.optional-product.product-include.filled').length;
        var prodIncludeCount = currentActiveTabContent.find('.product-wrapper.optional-product.product-include:not(.filled)').length;
        if (includedOptionalCount > 0 && prodIncludeCount == 0) {
          $(`.bundle-tab-control .tab-control[data-tab="${currentTabIndex}"]`).addClass('complete').removeClass('not-complete');
        } else if (prodIncludeCount > 0) {
          $(`.bundle-tab-control .tab-control[data-tab="${currentTabIndex}"]`).addClass('not-complete').removeClass('complete');
        } else {
          $(`.bundle-tab-control .tab-control[data-tab="${currentTabIndex}"]`).removeClass('complete not-complete');
        }
      }
      $('.bundle-step-container .bundle-tab-content').scrollTop(0);

      //mobile tab controls
      var tabInnerIndex = $(this).attr('data-mobtab');
      var currentTabContentMobile = $(`.tab-content .product-wrapper[data-mobtab="${currentTabInnerIndex}"]`);
      var currentProductCategoryMobile = $(`.tab-content .product-wrapper[data-mobtab="${currentTabInnerIndex}"]`).attr('data-itemcategory');
      if (currentTabContentMobile.hasClass('filled') && currentProductCategoryMobile != 'optional') {
        $(`.tab-c-mobile .tab-control[data-mobtab="${currentTabInnerIndex}"]`).addClass('complete').removeClass('not-complete');
      } else if (currentProductCategoryMobile == 'optional') {
        var currentTabIndex = currentActiveTabContent.attr('data-tab');
        var includedOptionalCount = currentActiveTabContent.find('.product-wrapper.optional-product.product-include.filled').length;
        var prodIncludeCount = currentActiveTabContent.find('.product-wrapper.optional-product.product-include:not(.filled)').length;

        if (includedOptionalCount > 0 && prodIncludeCount == 0) {
          $(`.tab-c-mobile .tab-control[data-mobtab="${currentTabContentMobile.attr('data-mobtab')}"]`).addClass('complete').removeClass('not-complete');
        } else if (prodIncludeCount > 0) {
          $(`.tab-c-mobile .tab-control[data-mobtab="${currentTabContentMobile.attr('data-mobtab')}"]`).addClass('not-complete').removeClass('complete');
        } else {
          $(`.tab-c-mobile .tab-control[data-mobtab="${currentTabContentMobile.attr('data-mobtab')}"]`).removeClass('complete not-complete');
        }
      } else {
        $(`.tab-c-mobile .tab-control[data-mobtab="${currentTabInnerIndex}"]`).addClass('not-complete').removeClass('complete');
      }

      // Desktop Tab click
      $(this).addClass('active').siblings().removeClass('active');
      $('.bundle-tab-content .tab-content[data-tab="'+tabId+'"]').addClass('active').siblings().removeClass('active');
      var currentMobileTab = $('.bundle-tab-content .tab-content .product-wrapper[data-mobtab="'+tabInnerIndex+'"]');
      currentMobileTab.addClass('active').siblings().not(currentMobileTab).removeClass('active');

      var thisOffsetLeft = parseFloat(currentMobileTab.find('.bundle-size-wrapper ul').attr('data-offsetleft'));
      if (thisOffsetLeft) {
        $('.bundle-tab-content .tab-content[data-tab="'+tabId+'"] .bundle-size-wrapper ul').scrollLeft(parseFloat(thisOffsetLeft - 15));
      }
      if($(this).hasClass('cta-bundle-preview')) {
        $('body.template-product.bundle-started .cart-icon').css("visibility", "visible");
        if ($(window).width() > 992) {
          $('body').addClass('active-bundle-review-popup');
          $('.bundle-review-popup .summary-image-preview').prepend(el.image3dPreview);
        } else {
          var tabId = $(this).attr('data-tab');
          $('body').addClass('bundle-mobile-expand');
          $(this).addClass('active').siblings().removeClass('active');
          $('.bundle-tab-content .tab-content[data-tab="'+tabId+'"]').addClass('active').siblings().removeClass('active');
        }
      }
    });

    $('.bundle-tab-content .tab-content .btn.cta-checkout, .tab-c-mobile .tab-content .btn.cta-checkout').on('click', function(e) {
      e.preventDefault();
      $('body').addClass('active-bundle-review-popup');
    });

    // Mobile continue button
    $('.tab-summary-footer .cta-continue a').on('click', function(e) {
      e.preventDefault();
      $('.tab-c-mobile .tab-control[data-mobtab="1"]').trigger('click').trigger('mousedown');
    });

    // Desktop Next Button click event
    $(document).on('click', '.bundle-tab-content .tab-content .tab-next.enabled a.btn', function(e) {
      e.preventDefault();
      var tabIndex = parseInt($(this).parents().eq(1).attr('data-tab'));
      $('.bundle-tab-control .tab-control[data-tab="'+parseInt(tabIndex + 1)+'"]').trigger('mousedown').trigger('click');
      $('.bundle-tab-control .tab-control[data-tab="'+parseInt(tabIndex)+'"]').addClass('complete');
      var productWrappers = $(this).parents().eq(1).find('.product-wrapper.filled');
      productWrappers.each(function() {
        var mobTabIndex = parseInt($(this).attr('data-mobtab'));
        $('.tab-c-mobile .tab-control[data-mobtab="'+parseInt(mobTabIndex)+'"]').addClass('complete');
      });
    });
    $('.bundle-tab-control .tab-control').on('click', function() {
        var eventName = 'desktop_tab-'+$(this).text();
        vm.pushEvent('BundleTracking', eventName);
    });
    $('.tab-c-mobile .tab-control').on('click', function() {
      var eventName = 'mobile_tab-'+$(this).text();
      vm.pushEvent('BundleTracking', eventName);
  });
  },
  bundleItemsCarousel: function() {
    // $('.product-options-slider')
    if ($(window).width() > 992) {
      if ($('.bundle-step-container .tab-c-mobile').hasClass('slick-initialized')) {
        $('.bundle-step-container .tab-c-mobile').slick('unslick');
        $('.bundle-step-container .tab-c-mobile').removeClass('slick-initialized slick-slider');
      }
    } else {
      if (!$('.bundle-step-container .tab-c-mobile').hasClass('slick-initialized')) {
        $('.bundle-step-container .tab-c-mobile').slick({
          infinite: false,
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          focusOnSelect: true,
          variableWidth: true,
					centerMode: true,
					swipeToSlide: true
        });
      }
    }
		$('.bundle-step-container .tab-c-mobile').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$('.bundle-step-container .tab-c-mobile').find('[data-slick-index="'+nextSlide+'"]').click();
		});
  },
  bundleMobileNav: function() {
    $('.mobile-nav-controls .btn').on('click', function(e) {
      e.preventDefault();
      var productWrapper = $(this).parents().eq(3);
      var mobTabIndex = parseInt(productWrapper.attr('data-mobtab'));
      var tabIndex = productWrapper.attr('data-tab');
      $('.bundle-tab-control .tab-control[data-tab="'+tabIndex+'"]').addClass('complete').removeClass('no-complete');
      $('.tab-c-mobile .tab-control[data-mobtab="'+mobTabIndex+'"]').addClass('complete').removeClass('no-complete');
      $(`.tab-c-mobile .tab-control[data-mobtab="${parseInt(mobTabIndex + 1)}"]`).trigger('mousedown').trigger('click');
      $('.tab-c-mobile .slick-next').trigger('click');
    });

    $('.mobile-nav-controls .mobile-nav-next .nav-next').on('click', function(e) {
      e.preventDefault();
      var mobTabIndex = parseInt($(this).parents().eq(3).attr('data-mobtab'));
      $('.tab-c-mobile .tab-control[data-mobtab="'+parseInt(mobTabIndex + 1)+'"]').trigger('mousedown');
      $('.tab-c-mobile .slick-next').trigger('click');
    });

    $('.tab-content[data-tab="4"] .mobile-nav-controls .btn, .tab-content[data-tab="4"] .mobile-nav-controls .mobile-nav-next .nav-next').on('click', function(e) {
      e.preventDefault();
      var tabWrapper = $(this).parents().eq(4);
      var mobTabIndex = parseInt(tabWrapper.find('.optional-row-wrapper .product-wrapper').eq(0).attr('data-mobtab'));
      var tabIndex = tabWrapper.attr('data-tab');
      $('.bundle-tab-control .tab-control[data-tab="'+tabIndex+'"]').addClass('complete').removeClass('no-complete');
      $('.tab-c-mobile .tab-control[data-mobtab="'+mobTabIndex+'"]').addClass('complete').removeClass('no-complete');
      $(`.tab-c-mobile .tab-control[data-mobtab="${parseInt(mobTabIndex + 1)}"]`).trigger('mousedown').trigger('click');
    });

    $('.mobile-nav-controls .mobile-nav-prev .nav-prev').on('click', function(e) {
      e.preventDefault();
      var mobTabIndex = parseInt($(this).parents().eq(3).attr('data-mobtab'));
      $('.tab-c-mobile .tab-control[data-mobtab="'+parseInt(mobTabIndex - 1)+'"]').trigger('mousedown').trigger('click');
      $('.tab-c-mobile .slick-prev').trigger('click');
    });

    $('.tab-content[data-tab="4"] .mobile-nav-controls .mobile-nav-prev .nav-prev').on('click', function(e) {
      e.preventDefault();
      var tabWrapper = $(this).parents().eq(4);
      var mobTabIndex = parseInt(tabWrapper.find('.optional-row-wrapper .product-wrapper').eq(0).attr('data-mobtab'));
      var tabIndex = tabWrapper.attr('data-tab');
      $('.bundle-tab-control .tab-control[data-tab="'+tabIndex+'"]').addClass('complete').removeClass('no-complete');
      $('.tab-c-mobile .tab-control[data-mobtab="'+mobTabIndex+'"]').addClass('complete').removeClass('no-complete');
      $(`.tab-c-mobile .tab-control[data-mobtab="${parseInt(mobTabIndex - 1)}"]`).trigger('mousedown').trigger('click');
      $('.tab-c-mobile .slick-prev').trigger('click');
    });
  },
  bundleOptionSelect: function() {
    var vm = this, el = vm.defaults;
    var storeLocation = $('body').attr('data-store-location');
    var lastClickedFlatSheet = '', lastClickedFittedSheet = '';
    $('.bundle-option-selector li a').on('click', function(e) {
      e.preventDefault();
      $(this).parent().addClass('selected');
      $(this).parent().siblings().removeClass('selected');
      var thisValue = $(this).attr('data-value');
      var thisValueText = $(this).attr('data-text');
      var thisProductWrapper = $(this).parents().eq(4);
      var itemType = thisProductWrapper.attr('data-itemtype');
      var variantRow = $(this).parents().eq(3);
      var prodType = variantRow.attr('data-prodtype');
      var thisOptionType = $(this).parents().eq(2).attr('data-optiontype');
      if (storeLocation == 'US') {
        if (thisOptionType == 'type' && (itemType == 'sheet' || itemType == 'sheet-optional')) {
          var validFittedSheetSize = ['twin', 'twin-xl', 'full', 'queen', 'king', 'cali-king'];
          var validFlatSheetSize = ['twin-twin-xl', 'full-queen', 'king-cali-king'];
          var selectedSize = thisProductWrapper.find('.bundle-size-wrapper li.selected a').attr('data-value');
          if (thisValue == 'flat-sheet') {
            lastClickedFittedSheet = selectedSize;
            $.each(validFlatSheetSize, function(i, v) {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="${v}"]`).parent().show();
            });
            $.each(validFittedSheetSize, function(i, v) {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="${v}"]`).parent().hide();
            });
          } else if (thisValue == 'fitted-sheet') {
            $.each(validFlatSheetSize, function(i, v) {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="${v}"]`).parent().hide();
            });
            $.each(validFittedSheetSize, function(i, v) {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="${v}"]`).parent().show();
            });
          }
          if (selectedSize != undefined && selectedSize != '' && thisValue == 'flat-sheet') {
            if (selectedSize == 'twin' || selectedSize == 'twin-xl') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="twin-twin-xl"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="twin-twin-xl"]`).parent().siblings().removeClass('selected');
            } else if (selectedSize == 'full' || selectedSize == 'queen') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="full-queen"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="full-queen"]`).parent().siblings().removeClass('selected');
            } else if (selectedSize == 'king' || selectedSize == 'cali-king') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="king-cali-king"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="king-cali-king"]`).parent().siblings().removeClass('selected');
            }
          } else if (selectedSize != undefined && selectedSize != '' && thisValue == 'fitted-sheet') {
            if (lastClickedFittedSheet != '') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="${lastClickedFittedSheet}"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="${lastClickedFittedSheet}"]`).parent().siblings().removeClass('selected');
            } else if (selectedSize == 'twin-twin-xl') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="twin"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="twin"]`).parent().siblings().removeClass('selected');
            } else if (selectedSize == 'full-queen') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="full"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="full"]`).parent().siblings().removeClass('selected');
            } else if (selectedSize == 'king-cali-king') {
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="king"]`).parent().addClass('selected');
              thisProductWrapper.find(`.bundle-size-wrapper li a[data-value="king"]`).parent().siblings().removeClass('selected');
            }
          }
        }
      }

      var eventName = `${thisOptionType}_${variantRow.attr('data-prodtype')}`;
      vm.pushEvent('BundleTracking', eventName);

      //Update the label text of the swatch being selected.
      if (thisOptionType == 'colour') {
        $(this).parents().eq(2).find('.selected-swatch-label p').text(thisValueText);
      }

      if (thisOptionType == 'size' && el.overRideSizeOffset) {
        var thisLeftOffset = parseFloat($(this).offset().left);
        $(this).parents().eq(1).attr('data-offsetleft', parseFloat(thisLeftOffset));
      }

      if (thisOptionType == 'size' && itemType != 'duvet') {
        el.applySizeAllOnce = false;
      }

      $(`.bundle-summary-items .item-details[data-itemtype="${prodType}"] .item-variant-attribute[data-optiontype="${thisOptionType}"]`).removeClass('not-filled');
      $(`.bundle-summary-items .item-details[data-itemtype="${prodType}"]`).removeClass('not-filled');
      $(`.bundle-summary-items .item-details[data-itemtype="${prodType}"] .item-variant-attribute[data-optiontype="${thisOptionType}"] span`).text(thisValueText);
      variantRow.find('.bundle-option-selector').each(function() {
        if ($(this).find('.selected a').length == 0) {
          $(`.bundle-summary-items .item-details[data-itemtype="${prodType}"] .item-title`).addClass('incomplete');
          return false;
        } else {
          $(`.bundle-summary-items .item-details[data-itemtype="${prodType}"]`).removeClass('not-filled');
          $(`.bundle-summary-items .item-details[data-itemtype="${prodType}"] .item-title`).removeClass('incomplete');
          return;
        }
      });

      el.imageBundleVars['sPillowCount'] = 1;
      el.imageBundleVars['ePillowCount'] = 0;
      el.imageBundleVars['fittedSheetCount'] = 1;
      el.imageBundleVars['flatSheetCount'] = 1;

      var isPillowCase = (prodType == 'pillowcase-separates' || prodType == 'pillowcase-optional');
      var isSheet = (prodType == 'sheet-separates' || prodType == 'sheet-optional');
      /* Update Pillowcase Index, and Count */
      if (thisOptionType == 'size' && isPillowCase) {
        if ((thisValue == 'standard-size' || thisValue == 'king-size')&& prodType == 'pillowcase-separates') {
          el.imageBundleVars['pillowSeparatesSize'] = 'standard-size';
        } else if (thisValue == 'european-size' && prodType == 'pillowcase-separates') {
          el.imageBundleVars['pillowSeparatesSize'] = 'european-size';
        } else if ((thisValue == 'standard-size' || thisValue == 'king-size') && prodType == 'pillowcase-optional') {
          el.imageBundleVars['pillowOptionalSize'] = 'standard-size';
        } else if (thisValue == 'european-size' && prodType == 'pillowcase-optional') {
          el.imageBundleVars['pillowOptionalSize'] = 'european-size';
        }
      }
      /* End Update Pillowcase Index, and Count */

      /* Update Sheet Index, and Count */
      if (thisOptionType == 'type' && isSheet) {
        if (thisValue == 'fitted-sheet' && prodType == 'sheet-separates') {
          el.imageBundleVars['sheetSeparatesType'] = 'fitted-sheet';
        } else if (thisValue == 'flat-sheet' && prodType == 'sheet-separates') {
          el.imageBundleVars['sheetSeparatesType'] = 'flat-sheet';
        } else if (thisValue == 'fitted-sheet' && prodType == 'sheet-optional') {
          el.imageBundleVars['sheetOptionalType'] = 'fitted-sheet';
        } else if (thisValue == 'flat-sheet' && prodType == 'sheet-optional') {
          el.imageBundleVars['sheetOptionalType'] = 'flat-sheet';
        }
      }

      if (itemType == 'sheet-optional') {
        el.imageBundleVars['incOptionalSheet'] = true;
      } else if (itemType == 'pillowcase-optional') {
        el.imageBundleVars['incOptionalPillow'] = true;
      } else if (itemType == 'candle-optional') {
        el.imageBundleVars['incOptionalCandle'] = true;
      }
      vm.getPillowIndex();
      vm.getSheetIndex();

      vm.checkAllItemsIfFilled($(this));
      vm.bundle3dImageUpdate(thisValue, prodType, thisOptionType);

    });
  },
  bundleOptionalItemSelect: function() {
    var vm = this, el = vm.this;
    // Collapse / Expand optional items' variant options
    $('.product-wrapper[data-itemcategory="optional"] .option-t-wrapper .option-text label').on('click', function() {
      if ($(this).parents().eq(2).hasClass('optional-active')) {
        $(this).parents().eq(2).removeClass('optional-active');
      } else {
        $(this).parents().eq(2).toggleClass('optional-active');
        $(this).parents().eq(2).siblings().removeClass('optional-active');
      }
    });
  },
  applySizeToAll: function() {
    var vm = this, el = vm.defaults;
    var duvetSizeSelected = $(`.product-wrapper[data-itemtype="duvet"] .bundle-size-wrapper .selected a`);
    var offsetSize = ($(`.product-wrapper[data-itemtype="duvet"] .bundle-size-wrapper .selected a`).length > 0) ? $(`.product-wrapper[data-itemtype="duvet"] .bundle-size-wrapper .selected a`).offset().left : 0;
    var duvetSizeVal = duvetSizeSelected.attr('data-value');
    var duvetSizeVal = duvetSizeSelected.attr('data-value');
    if (el.applySizeAllOnce == true && duvetSizeSelected.length > 0) {
      $('.product-wrapper:not([data-itemtype="duvet"]):not([data-itemcategory="optional"])').each(function() {
        var thisSizeButton= $(this).find(`.bundle-option-selector[data-optiontype="size"] .size-selector a[data-value="${duvetSizeVal}"]`);
        if (thisSizeButton.length > 0) {
          $(this).find(`.bundle-option-selector[data-optiontype="size"] .size-selector a[data-value="${duvetSizeVal}"]`).parents().eq(1).attr('data-offsetleft', offsetSize);
          $(this).find(`.bundle-option-selector[data-optiontype="size"] .size-selector a[data-value="${duvetSizeVal}"]`).trigger('click');
        }
      });
      el.applySizeAllOnce = false;
    }
    $('.implement-size-wrapper #apply-size-all').on('change', function(e) {
      e.preventDefault();
      var sizeVal = $(this).parents().eq(1).find('.bundle-option-selector[data-optiontype="size"] .selected a').attr('data-value');
      var thisChecked = $(this).is(':checked');
      if (thisChecked) {
        $('.product-wrapper:not([data-prodtype="duvet"])').each(function() {
          $(this).find(`.bundle-option-selector[data-optiontype="size"] .size-selector a[data-value="${sizeVal}"]`).trigger('click');
        });
      }
    });
  },
  optionalCheckbox: function() {
    var vm = this,  el = vm.defaults;
    $('.product-wrapper.optional-product .option-text .optional-checkbox').on('change', function() {
      var itemType = $(this).parents().eq(2).attr('data-itemtype');
      var prodWrapper = $(this).parents().eq(2);
      if($(this).is(':checked')) {
        $(this).parents().eq(2).addClass('product-include optional-active');
        $(`.bundle-summary-items .bundle-set-row .item-details[data-itemtype="${itemType}"]`).removeClass('hide');

        if (itemType == 'sheet-optional') {
          el.imageBundleVars['incOptionalSheet'] = true;
        } else if (itemType == 'pillowcase-optional') {
          el.imageBundleVars['incOptionalPillow'] = true;
        } else if (itemType == 'candle-optional') {
          el.imageBundleVars['incOptionalCandle'] = true;
        }
      } else {
        $(this).parents().eq(2).removeClass('product-include optional-active');
        $(`.bundle-summary-items .bundle-set-row .item-details[data-itemtype="${itemType}"]`).addClass('hide');
        if (itemType == 'sheet-optional') {
          el.imageBundleVars['incOptionalSheet'] = false;
        } else if (itemType == 'pillowcase-optional') {
          el.imageBundleVars['incOptionalPillow'] = false;
        } else if (itemType == 'candle-optional') {
          el.imageBundleVars['incOptionalCandle'] = false;
        }
      }
      prodWrapper.find('.variant-options .bundle-option-selector').each(function() {
        var thisSelected = $(this).find('.selected');
        if (thisSelected.length != 0) {
          prodWrapper.addClass('filled');
          return;
        } else {
          prodWrapper.removeClass('filled');
          return false;
        }
      });
      el.imageBundleVars['sPillowCount'] = 1;
      el.imageBundleVars['ePillowCount'] = 0;
      el.imageBundleVars['fittedSheetCount'] = 1;
      el.imageBundleVars['flatSheetCount'] = 1;

      vm.getPillowIndex();
      vm.getSheetIndex();

      vm.bundleItemsBuildJSON();
      vm.bundle3dImageUpdate();

      var includedOptionalCount = $(this).parents().eq(3).find('.product-wrapper.optional-product.product-include.filled').length;
      var prodIncludeCount = $(this).parents().eq(3).find('.product-wrapper.optional-product.product-include:not(.filled)').length;
      var optionalItemCount = el.bundleItems['optional-items'].length;

      var validOptionalItems = ((prodIncludeCount == 0 && includedOptionalCount >= 0 && optionalItemCount >= 0));
      var dataTab = $(this).parents().eq(5).attr('data-tab');

      if (validOptionalItems) {
        // $(`.bundle-tab-control .tab-control[data-tab=${dataTab}]`).addClass('complete');
        $(`.bundle-tab-content .tab-content[data-tab=${dataTab}] .cta.tab-next`).addClass('enabled');
        $(`.bundle-tab-content .tab-content[data-tab=${dataTab}] .mobile-nav-controls .btn-next-wrapper`).addClass('enabled');
      } else {
        // $(`.bundle-tab-control .tab-control[data-tab=${dataTab}]`).removeClass('complete');
        $(`.bundle-tab-content .tab-content[data-tab=${dataTab}] .cta.tab-next`).removeClass('enabled');
        $(`.bundle-tab-content .tab-content[data-tab=${dataTab}] .mobile-nav-controls .btn-next-wrapper`).removeClass('enabled');
      }
      // if (optionalItemCount == 0 || prodIncludeCount > 0) {
      //   $(`.bundle-tab-control .tab-control[data-tab=${dataTab}]`).removeClass('complete');
      // } else {
      //   $(`.bundle-tab-control .tab-control[data-tab=${dataTab}]`).addClass('complete');
      // }

      // Show / Hide Summary items on summary popup when toggling the optional items' checkbox.
      if ($('.product-wrapper.optional-product.product-include').length > 0) {
        $(`.bundle-summary-items .bundle-set-row.optional-summary-row`).addClass('include-optional').removeClass('hide');
      } else {
        $(`.bundle-summary-items .bundle-set-row.optional-summary-row`).removeClass('include-optional').addClass('hide');
      }
    });
  },
  getPillowIndex: function() {
    var vm = this, el = vm.defaults;
    if (el.imageBundleVars['pillowSeparatesSize'] == 'standard-size') {
      el.imageBundleVars['sPillowCount'] = parseInt(el.imageBundleVars['sPillowCount']) + 1;
      el.imageBundleVars['pillowSeparatesIndex'] = 2;
    }
    if (el.imageBundleVars['pillowOptionalSize'] == 'standard-size' && el.imageBundleVars['incOptionalPillow'] == true) {
      el.imageBundleVars['sPillowCount'] = parseInt(el.imageBundleVars['sPillowCount']) + 1;
      if (el.imageBundleVars['pillowSeparatesSize'] == 'standard-size') {
        el.imageBundleVars['pillowOptionalIndex'] = 3;
      } else if (el.imageBundleVars['pillowSeparatesSize'] == 'european-size'){
        el.imageBundleVars['pillowOptionalIndex'] = 2;
      }
    }

    if (el.imageBundleVars['pillowSeparatesSize'] == 'european-size') {
      el.imageBundleVars['ePillowCount'] = parseInt(el.imageBundleVars['ePillowCount']) + 1;
      el.imageBundleVars['pillowSeparatesIndex'] = 1;
    }
    if (el.imageBundleVars['pillowOptionalSize'] == 'european-size' && el.imageBundleVars['incOptionalPillow'] == true) {
      el.imageBundleVars['ePillowCount'] = parseInt(el.imageBundleVars['ePillowCount']) + 1;
      if (el.imageBundleVars['pillowSeparatesIndex'] == 1) {
        el.imageBundleVars['pillowOptionalIndex'] = 2;
      } else if (el.imageBundleVars['pillowSeparatesIndex'] == 2){
        el.imageBundleVars['pillowOptionalIndex'] = 1;
      }
    }
  },
  getSheetIndex: function() {
    var vm = this, el = vm.defaults;
    if (el.imageBundleVars['sheetSeparatesType'] == 'fitted-sheet') {
      el.imageBundleVars['fittedSheetCount'] = parseInt(el.imageBundleVars['fittedSheetCount']) + 1;
      el.imageBundleVars['sheetSeparatesIndex'] = 2;
    }
    if (el.imageBundleVars['sheetOptionalType'] == 'fitted-sheet' && el.imageBundleVars['incOptionalSheet'] == true) {
      el.imageBundleVars['fittedSheetCount'] = parseInt(el.imageBundleVars['fittedSheetCount']) + 1;
      if (el.imageBundleVars['sheetSeparatesType'] == 'fitted-sheet') {
        el.imageBundleVars['sheetOptionalIndex'] = 3;
      } else if (el.imageBundleVars['sheetSeparatesType'] == 'flat-sheet'){
        el.imageBundleVars['sheetOptionalIndex'] = 2;
      }
    }

    if (el.imageBundleVars['sheetSeparatesType'] == 'flat-sheet') {
      el.imageBundleVars['flatSheetCount'] = 1;
      el.imageBundleVars['sheetSeparatesIndex'] = 1;
    }
    if (el.imageBundleVars['sheetOptionalType'] == 'flat-sheet' && el.imageBundleVars['incOptionalSheet'] == true) {
      el.imageBundleVars['flatSheetCount'] = parseInt(el.imageBundleVars['flatSheetCount']) + 1;
      if (el.imageBundleVars['sheetSeparatesType'] == 'fitted-sheet') {
        el.imageBundleVars['sheetOptionalIndex'] = 1;
      } else if (el.imageBundleVars['sheetSeparatesType'] == 'flat-sheet'){
        el.imageBundleVars['sheetOptionalIndex'] = 2;
      }
    }
  },
  bundlePreview: function() {
    var vm = this, el = vm.defaults;
    $(document).on('click', '.bundle-summary-items .item-details .cta-edit', function(e) {
      e.preventDefault();
      var tabIndex = $(this).attr('data-tab');
      var mobTabIndex = $(this).attr('data-mobtab');
      $('.product-bundle-wrapper.bundle-main-frame .col-right').prepend(el.image3dPreview);
      $('body').removeClass('active-bundle-review-popup');
      if ($(window).width() > 992) {
        $('.bundle-tab-control .tab-control[data-tab="'+tabIndex+'"]').trigger('click').trigger('mousedown');
      } else {
        $('.tab-c-mobile .tab-control[data-mobtab="'+mobTabIndex+'"]').trigger('click').trigger('mousedown');
      }
    });

    $('.bundle-review-popup .btn-close-checkout').on('click', function() {
      $('.product-bundle-wrapper.bundle-main-frame .col-right').prepend(el.image3dPreview);
      $('body').removeClass('active-bundle-review-popup');
    });

    $('.bundle-summary-items .item-variant-attribute.not-filled').on('click', function(e) {
      e.preventDefault();
      var thisEditBtn = $(this).parent().find('.cta-edit');
      thisEditBtn.trigger('click');
    });
  },
  checkAllItemsIfFilled: function(btnElem) {
    var vm = this, el = this.defaults;
    var thisVariantWrapper = btnElem.parents().eq(3);
    var productWrapper = btnElem.parents().eq(4);
    var mobTabIndex = productWrapper.attr('data-mobtab');
    var tabWrapper = btnElem.parents().eq(6);
    var variantAttrs = '';
    var prodSliderWrapper = btnElem.parents().eq(5);

    thisVariantWrapper.find('.bundle-option-selector').each(function() {
      var thisOptionType = $(this).attr('data-optiontype');
      var thisOptionValue = $(this).find('.selected a').attr('data-value');

      if (thisOptionType == 'scent') {
        variantAttrs += `[value="${thisOptionValue}"]`
      } else {
        variantAttrs += `[data-${thisOptionType}="${thisOptionValue}"]`;
      }
    });

    var selectObj = productWrapper.find('select');
    var selectedVariant = productWrapper.find(`select option${variantAttrs}`).attr('value');

    if (selectedVariant != undefined && selectedVariant != '') {
      selectObj.val(selectedVariant);
      productWrapper.addClass('filled');
      if (productWrapper.hasClass('optional-product')) {
        $(`.bundle-tab-content .tab-content[data-tab=${btnElem.parents().eq(7).attr('data-tab')}] .mobile-nav-controls .btn-next-wrapper`).addClass('enabled');
        $(`.bundle-tab-content .tab-content[data-tab=${btnElem.parents().eq(7).attr('data-tab')}] .cta.tab-next`).addClass('enabled');
      }
    } else {
      productWrapper.removeClass('filled');
      if (productWrapper.hasClass('optional-product')) {
        $(`.bundle-tab-content .tab-content[data-tab=${btnElem.parents().eq(7).attr('data-tab')}] .mobile-nav-controls .btn-next-wrapper`).removeClass('enabled');
        $(`.bundle-tab-content .tab-content[data-tab=${btnElem.parents().eq(7).attr('data-tab')}] .cta.tab-next`).removeClass('enabled');
      }
    }

    var productCount = prodSliderWrapper.find('.product-wrapper').length;
    var productFilledCount = prodSliderWrapper.find('.product-wrapper.filled').length;

    if (productCount == productFilledCount) {
      tabWrapper.find('.tab-next').addClass('enabled');
      if (!productWrapper.hasClass('optional-product')) {
        tabWrapper.find('.mobile-nav-controls .btn-next-wrapper').addClass('enabled');
      }
    } else {
      tabWrapper.find('.tab-next').removeClass('enabled');
      if (!productWrapper.hasClass('optional-product')) {
        tabWrapper.find('.mobile-nav-controls .btn-next-wrapper').removeClass('enabled');
      }
    }
    vm.bundleItemsBuildJSON();
  },
  bundleItemsBuildJSON: function() {
		var vm = this;
		var el = vm.defaults;
    var requiredRows = [];
    var separateRows = [];
    var optionalRows = [];
    var sameColour = false;
    $('.bundle-tab-content .tab-content .product-wrapper.filled').each(function() {
      var sheetType = '', pillowType = '', scent;
      var selectedVariantType = $(this).attr('data-itemtype');
      var selecedVariantID = $(this).find('select').val();
      if (selectedVariantType == 'sheet' || selectedVariantType == 'sheet-optional') {
        sheetType = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-type');
      }
      if (selectedVariantType == 'pillowcase' || selectedVariantType == 'pillowcase-optional') {
        pillowType = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-type');
      }
      if (selectedVariantType == 'candle-optional') {
        scent = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-scent');
      }
      var selecedVariantTitle = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-title');
      var selecedVariantClabel= $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-colourlabel');
      var selecedVariantColour = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-colour');
      var selecedVariantSlabel= $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-sizelabel');
      var selecedVariantSize = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-size');
      var selectedVariantImgUrl = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-imgurl');
      var selectedVariantInventory = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-inv-available');
      var selectedVariantPrice = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-price');
      var selectedVariantUrl = $(this).find('select option[value="'+selecedVariantID+'"]').attr('data-url');
      var thisCategory = $(this).attr('data-itemcategory');
      var preorderValue = ($(this).attr('data-preorder-value')) ? $(this).attr('data-preorder-value') : '';
      var thisObj = {'itemtype': selectedVariantType,'id':selecedVariantID, 'sheettype': sheetType, 'title': selecedVariantTitle, 'colourlabel': selecedVariantClabel, 'colour': selecedVariantColour, 'sizelabel': selecedVariantSlabel, 'size': selecedVariantSize, 'inventory': selectedVariantInventory, 'image': selectedVariantImgUrl, 'price': selectedVariantPrice, 'url': selectedVariantUrl, 'pillowtype': pillowType, 'scent': scent }
      if (preorderValue != undefined && preorderValue != '') {
        thisObj['preorder-value'] = parseInt(preorderValue);
      }

      if (thisCategory == 'required') {
        requiredRows.push(thisObj);
      } else if (thisCategory == 'separates') {
        separateRows.push(thisObj);
      } else if (thisCategory == 'optional' && $(this).hasClass('product-include')) {
        optionalRows.push(thisObj);
      }

      el.bundleItems = {'required-items': requiredRows, 'separate-items':separateRows, 'optional-items' : optionalRows};
    });
    var requiredItems = el.bundleItems['required-items'];
    var separateItems = el.bundleItems['separate-items'];

    if (requiredItems.length == 3 && separateItems.length == 2) {
      vm.validBedSetCheck(requiredItems);
    }

    var prodWrapperFilledCount = $('.product-options-slider .product-wrapper.optional-product.product-include.filled').length;
    var prodIncludeCount = $('.product-options-slider .product-wrapper.optional-product.product-include:not(.filled)').length;

    var validOptionalItems = ((prodIncludeCount == 0 && prodWrapperFilledCount >= 1) || (prodWrapperFilledCount == 0 && prodIncludeCount == 0));
    if (el.bundleItems['required-items'].length == 3 && el.bundleItems['separate-items'].length == 2 && validOptionalItems) {
      //$('.bundle-review-popup .preview-wrapper .bundle-add-controls, .bundle-review-popup .bundle-review-drawer .mobile-atc-wrapper').removeClass('hide');
      $('body').addClass('checkout-valid');
      $('.bundle-review-popup .preview-wrapper .bundle-add-controls, .bundle-review-popup .bundle-review-drawer .mobile-atc-wrapper .cta-checkout').removeClass('hide');
      $('.mobile-checkout .cta-checkout-wrapper .cta-addtocart-bundle').removeClass('hide');
      $('.tab-content .mobile-checkout .reg-price, .tab-content .mobile-checkout .bundle-price-wrapper, .tab-content .mobile-checkout .afterpay-wrapper, .bundle-review-popup .reg-price').removeClass('no-bprice');
      $('.bundle-review-popup .preview-wrapper .bundle-add-note, .bundle-review-popup .bundle-review-drawer .bundle-add-note, .tab-content .bundle-add-note').addClass('hide');
    } else {
      //$('.bundle-review-popup .preview-wrapper .bundle-add-controls, .bundle-review-popup .bundle-review-drawer .mobile-atc-wrapper').addClass('hide');
      $('body').removeClass('checkout-valid');
      $('.bundle-review-popup .preview-wrapper .bundle-add-controls, .bundle-review-popup .bundle-review-drawer .mobile-atc-wrapper .cta-checkout').addClass('hide');
      $('.mobile-checkout .cta-checkout-wrapper .cta-addtocart-bundle').addClass('hide');
      $('.tab-content .mobile-checkout .reg-price, .tab-content .mobile-checkout .bundle-price-wrapper, .tab-content .mobile-checkout .afterpay-wrapper, .bundle-review-popup .reg-price').addClass('no-bprice');
      $('.bundle-review-popup .preview-wrapper .bundle-add-note, .bundle-review-popup .bundle-review-drawer .bundle-add-note, .tab-content .bundle-add-note').removeClass('hide');
    }

    if (el.bundleItems['optional-items'].length == 0) {
      $('.bundle-summary-items .bundle-set-row.optional-summary-row').addClass('hide');
    } else {
      $('.bundle-summary-items .bundle-set-row.optional-summary-row').removeClass('hide');
    }

  },
  validBedSetCheck: function(requiredItems) {
    var vm = this, el = vm.defaults;
    el.isBedSet = false;
    el.bedSetBreakDown = false;
    vm.computeBundlePrice(el.isBedSet, '');
    vm.bundleItemsToAddCart(el.isBedSet, '', el.bedSetBreakDown);
  },
  computeBundlePrice: function(isBedSet, bedSetObj) {
		var vm = this;
    var el = vm.defaults;
		var discount = (isBedSet == true) ? 0.9 : 0.8; // if default bedding set is matched, apply 10% discount and 20% discount if not matched. (Will always be 20% discount as of 28, Jan. 2021);
    if (isBedSet == true) {
			var totalBundlePrice = 0;
			var totalSeparatesPrice = 0;
      var totalOptionalsPrice = 0;
      var totalrequiredPrice = 0;
      var totalRegPrice = 0;
			$.each(el.bundleItems['separate-items'], function(ind, val) {
				totalSeparatesPrice += parseInt(val.price);
			});
			$.each(el.bundleItems['optional-items'], function(ind, val) {
				totalOptionalsPrice += parseInt(val.price);
			});
      totalBundlePrice = (parseInt(bedSetObj.price) + totalSeparatesPrice + totalOptionalsPrice) * discount;
       /* THIS IS FOR THE REGULAR PRICE COMPUTATION ONLY */
       $.each(el.bundleItems['required-items'], function(ind, val) {
				totalrequiredPrice += parseInt(val.price);
      });
      totalRegPrice = (totalrequiredPrice + totalSeparatesPrice + totalOptionalsPrice);
      /* END of THE REGULAR PRICE COMPUTATION */
		} else {
			var totalrequiredPrice = 0, totalRequiredPriceDiscounted = 0;
			var totalSeparatesPrice = 0, totalSeparatesPriceDiscounted = 0;
			var totalOptionalsPrice = 0, totalOptionalsPriceDiscounted = 0;
			$.each(el.bundleItems['required-items'], function(ind, val) {
				totalrequiredPrice += parseInt(val.price);
        var itemPriceDiscounted = parseInt(val.price) * 0.8;
        if (el.roundOffToggle == 'true') {
          itemPriceDiscounted = vm.roundOffFunction(parseInt(itemPriceDiscounted));
        }
        totalRequiredPriceDiscounted += itemPriceDiscounted;
			});
			$.each(el.bundleItems['separate-items'], function(ind, val) {
				totalSeparatesPrice += parseInt(val.price);
        var itemPriceDiscounted = parseInt(val.price) * 0.8;
        if (el.roundOffToggle == 'true') {
          itemPriceDiscounted = vm.roundOffFunction(parseInt(itemPriceDiscounted));
        }
        totalRequiredPriceDiscounted += itemPriceDiscounted;
			});
			$.each(el.bundleItems['optional-items'], function(ind, val) {
				totalOptionalsPrice += parseInt(val.price);
        var itemPriceDiscounted = parseInt(val.price) * 0.8;
        if (el.roundOffToggle == 'true') {
          itemPriceDiscounted = vm.roundOffFunction(parseInt(itemPriceDiscounted));
        }
        totalRequiredPriceDiscounted += itemPriceDiscounted;
			});
      totalBundlePrice = (totalRequiredPriceDiscounted + totalSeparatesPriceDiscounted + totalOptionalsPriceDiscounted);
      totalRegPrice = (totalrequiredPrice + totalSeparatesPrice + totalOptionalsPrice);
		}

    var totalDiscountApplied = totalRegPrice - totalBundlePrice;

    // TODO: replace with proper format currency function
    $('.tab-content .mobile-checkout .subtotal-price, .bundle-review-popup .reg-price').text(`$${parseFloat(totalRegPrice / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
    $('.tab-content .mobile-checkout .discount-price').text(`-$${parseFloat(totalDiscountApplied / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
    $('.tab-content .mobile-checkout .bundle-price').text(`$${parseFloat(totalBundlePrice / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
    $('.bundle-review-popup .bundle-price').text(`$${parseFloat(totalBundlePrice / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
    $('.bundle-review-drawer .mobile-atc-wrapper .bundle-price').text(` - $${parseFloat(totalBundlePrice / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
    $('.tab-content .mobile-checkout .afterpay-wrapper .afterpay-price').text(`$${parseFloat((totalBundlePrice / 100 )/ 4).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
    $('.bundle-review-popup .afterpay-wrapper .afterpay-price').text(`$${parseFloat((totalBundlePrice / 100 )/ 4).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")} ${el.currencyLabel}`);
		el.totalBundlePrice = totalBundlePrice;
	},
  bundleItemsToAddCart: function(isBedSet, bedSetObj, breakDown) {
		var vm = this;
		var el = vm.defaults;
    var bundleAddObj = [];
		var now = jQuery.now(); // date time for parent bundle ID
    var parentBundleId = $('.bundle-product-meta').attr('data-parentid');
    var parentBundleInventory = $('.bundle-product-meta').attr('data-inv-available');
    var parentBundleUrl = $('.bundle-product-meta').attr('data-url');
    if (isBedSet == true && breakDown == true) {
			var parentBreakDownItems = [];
			$.each(el.bundleItems['required-items'], function(ind, val) {
				var itemBreakDown = {
					'title': val.title,
					'url': val.url,
					'imgurl': val.image,
          'variantoptions': val.colourlabel + ' / ' + val.sizelabel,
          'inventory': val.inventory
				};
				parentBreakDownItems.push(itemBreakDown);
      });
			var parentProperties = {
				'ParentBundle': now,
				'ParentPrice': el.totalBundlePrice,
				'BedSetBreakdown': JSON.stringify(parentBreakDownItems)
			}
			var parentObj = {
				variant_id: parseInt(parentBundleId),
				quantity: 1,
				inventory: bedSetObj.inventory,
        properties: parentProperties,
      }
      bundleAddObj.push(parentObj);

      /* Add Bedding Set Item to Cart as hidden bundle item */
      var bedSetAddObj = {
        variant_id: parseInt(bedSetObj.id),
				quantity: 1,
				inventory: bedSetObj.inventory,
				properties: {
          'Bundle': now,
          'HiddenItem': 'yes'
        }
      }
      if (parseInt(bedSetObj.inventory) <= 0) {
        var preOrderMessage = parseInt(bedSetObj['preorder-value']) - 1;
        bedSetAddObj.properties['PreOrder'] = `Available On Backorder - ${el.monthLabels[preOrderMessage]}`;
      }
      bundleAddObj.push(bedSetAddObj);
		} else {
      var parentProperties = {
				'ParentBundle': now,
				'ParentPrice': el.totalBundlePrice,
			}
			var parentObj = {
				variant_id: parseInt(parentBundleId),
				quantity: 1,
				inventory: parentBundleInventory,
        properties: parentProperties,
        url: parentBundleUrl
      }
      bundleAddObj.push(parentObj);
      $.each(el.bundleItems['required-items'], function(ind, val) {
        var bItemObj = {};
        var rawPrice = parseInt(val.price) * 0.8;
        // var loopDiscount = 0;
        // if (el.loopActive == true) {
        //   loopDiscount = (parseInt(val.price) - rawPrice) / 100;
        // }
        if (el.roundOffToggle == 'true') {
          rawPrice = vm.roundOffFunction(parseInt(rawPrice));
        }
        var itemProperties = {
          'Bundle': now,
          'ItemPrice': rawPrice,
          // 'loopDiscount': loopDiscount
        };
        if (parseInt(val.inventory) <= 0) {
          var preOrderMessage = parseInt(val['preorder-value']) - 1;
          itemProperties['PreOrder'] = `Available On Backorder - ${el.monthLabels[preOrderMessage]}`;
        }
        bItemObj =  {
          variant_id: parseInt(val.id),
          quantity: 1,
          inventory: parseInt(val.inventory),
          properties: itemProperties,
          url: val.url
        }
        bundleAddObj.push(bItemObj);
      });
    }
    $.each(el.bundleItems['separate-items'], function(ind, val) {
      var bItemObj = {};
      var rawPrice = parseInt(val.price) * 0.8;
      // var loopDiscount = 0;
      // if (el.loopActive == true) {
      //   loopDiscount = (parseInt(val.price) - rawPrice) / 100;
      // }
      if (el.roundOffToggle == 'true') {
        rawPrice = vm.roundOffFunction(parseInt(rawPrice));
      }
      var itemProperties = {
        'Bundle': now,
        'ItemPrice': rawPrice,
        // 'loopDiscount': loopDiscount
      };
      if (parseInt(val.inventory) <= 0) {
        var preOrderMessage = parseInt(val['preorder-value']) - 1;
        itemProperties['PreOrder'] = `Available On Backorder - ${el.monthLabels[preOrderMessage]}`;
      }
      bItemObj =  {
        variant_id: parseInt(val.id),
        quantity: 1,
        inventory: parseInt(val.inventory),
        properties: itemProperties,
        url: val.url
      }
      bundleAddObj.push(bItemObj);
    });
    $.each(el.bundleItems['optional-items'], function(ind, val) {
      var bItemObj = {};
      var rawPrice = parseInt(val.price) * 0.8;
      // var loopDiscount = 0;
      // if (el.loopActive == true) {
      //   loopDiscount = (parseInt(val.price) - rawPrice) / 100;
      // }
      if (el.roundOffToggle == 'true') {
        rawPrice = vm.roundOffFunction(parseInt(rawPrice));
      }
      var itemProperties = {
        'Bundle': now,
        'ItemPrice': rawPrice,
        // 'loopDiscount': loopDiscount
      };
      if (parseInt(val.inventory) <= 0) {
        var preOrderMessage = parseInt(val['preorder-value']) - 1;
        itemProperties['PreOrder'] = `Available On Backorder - ${el.monthLabels[preOrderMessage]}`;
      }
      bItemObj =  {
        variant_id: parseInt(val.id),
        quantity: 1,
        inventory: parseInt(val.inventory),
        properties: itemProperties,
        url: val.url
      }
      bundleAddObj.push(bItemObj);
    });
    el.addBundleItemsObj = bundleAddObj.reverse();

	},
  ajaxAddBundleToCart: function() {
		var vm = this;
    var el = vm.defaults;
    vm.bundleItemsToAddCart(el.isBedSet, el.bedSetObj, el.bedSetBreakDown);
    var itemsToAdd = [];
		if (el.addBundleItemsObj.length != 0) {
			$.each(el.addBundleItemsObj, function(ind, val) {
        var indexOfExistingItem = itemsToAdd.findIndex(bundleItem => bundleItem.id === val.variant_id);
        var stringurl = (val.url) ? val.url : '';
        var handle = stringurl.replace('/products/', '');
        if (indexOfExistingItem > -1) {
          itemsToAdd[indexOfExistingItem].quantity = itemsToAdd[indexOfExistingItem].quantity + val.quantity;
          itemsToAdd[indexOfExistingItem].properties.ItemPrice = itemsToAdd[indexOfExistingItem].properties.ItemPrice + val.properties.ItemPrice;
        } else {
          var itemObj = { quantity: val.quantity, id: val.variant_id, properties: val.properties};
          if (handle != '') {
            itemObj.handle = handle;
          }
          itemsToAdd.push(itemObj);
        }
      });
      $('.product-3d-bundle a.cta-checkout, .bundle-review-p-wrapper a.cta-checkout').addClass('loading');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {
          items: itemsToAdd
        },
        dataType: 'json',
        success: function() {
          updateCartDrawer();
          bundleAdded();
          $('.product-bundle-wrapper.bundle-main-frame .col-right').prepend(el.image3dPreview);
          $('body').removeClass('active-bundle-review-popup');
          // $('.cart-drawer-wrapper').addClass('active');
          // setTimeout(function() {
          //   $('cart-drawer').removeClass('active-bundle-review-popup');
          // }, 3000);
          $('.product-3d-bundle a.cta-checkout.loading, .bundle-review-p-wrapper a.cta-checkout.loading').removeClass('loading');
        },
        error: function() {
        }
      });
		}
  },
  initiateBundle3dImage: function() {
    /* This function can be used to instatiate the 3d bundle image with starting properties
        i.e: White pillow, sheets, and duvets etc.
    */
    var vm = this;
    var el = vm.defaults;
    var bundleJSON = JSON.stringify(el.imageBundleConfig);
    var newScript = document.createElement("script");
    var inlineScript = document.createTextNode("'"+bundleJSON+"'");
    newScript.setAttribute("id", "bundle3dImageConfig");
    newScript.setAttribute("glasshouse-configurator-json", "");
    newScript.type = "text/javascript";
    newScript.appendChild(inlineScript);
    document.getElementById('ProductBundleBuilder3d').appendChild(newScript);
  },
  bundle3dImageUpdate: function(thisVal, thisProdType, thisOptionType) {
    // This Function is for the update of the 3d Bundle Image.
    var vm = this, el = vm.defaults;
    if (thisOptionType == 'colour' || thisOptionType == 'color') {
      if (thisProdType == 'duvet') {
        el.image3dVarHolder["0"].selectedOption = thisVal;
      } else if (thisProdType == 'sheet') {
        el.image3dVarHolder["1"].selectedOption = thisVal;
      } else if (thisProdType == 'pillowcase') {
        el.image3dVarHolder["2"].selectedOption = thisVal;
      } else if (thisProdType == 'sheet-separates') {
        el.image3dVarHolder["3"].selectedOption = thisVal;
      } else if (thisProdType == 'pillowcase-separates') {
        el.image3dVarHolder["4"].selectedOption = thisVal;
      } else if (thisProdType == 'sheet-optional') {
        el.image3dVarHolder["5"].selectedOption = thisVal;
      } else if (thisProdType == 'pillowcase-optional') {
        el.image3dVarHolder["6"].selectedOption = thisVal;
      }
    }

    el.image3dVarHolder["1"].fabricSection = `fitted-sheet_1_${el.imageBundleVars['fittedSheetCount']}`;
    el.image3dVarHolder["2"].fabricSection = `standard-pillowcase_1_${el.imageBundleVars['sPillowCount']}_${el.imageBundleVars['ePillowCount']}`;

    if (el.imageBundleVars['sheetSeparatesType'] == 'fitted-sheet') {
      el.image3dVarHolder["3"].fabricSection = `${el.imageBundleVars['sheetSeparatesType']}_${el.imageBundleVars['sheetSeparatesIndex']}_${el.imageBundleVars['fittedSheetCount']}`;
    } else if (el.imageBundleVars['sheetSeparatesType'] == 'flat-sheet') {
      el.image3dVarHolder["3"].fabricSection = `${el.imageBundleVars['sheetSeparatesType']}_${el.imageBundleVars['sheetSeparatesIndex']}_${el.imageBundleVars['flatSheetCount']}`;
    }

    if (el.imageBundleVars['pillowSeparatesSize'] == 'standard-size') {
      el.image3dVarHolder["4"].fabricSection = `standard-pillowcase_${el.imageBundleVars['pillowSeparatesIndex']}_${el.imageBundleVars['sPillowCount']}_${el.imageBundleVars['ePillowCount']}`;
    } else if (el.imageBundleVars['pillowSeparatesSize'] == 'european-size') {
      el.image3dVarHolder["4"].fabricSection = `european-pillowcase_${el.imageBundleVars['pillowSeparatesIndex']}_${el.imageBundleVars['ePillowCount']}`;
    }

    if (el.imageBundleVars['sheetOptionalType'] == 'fitted-sheet') {
      el.image3dVarHolder["5"].fabricSection = `${el.imageBundleVars['sheetOptionalType']}_${el.imageBundleVars['sheetOptionalIndex']}_${el.imageBundleVars['fittedSheetCount']}`;
    } else if (el.imageBundleVars['sheetOptionalType'] == 'flat-sheet') {
      el.image3dVarHolder["5"].fabricSection = `${el.imageBundleVars['sheetOptionalType']}_${el.imageBundleVars['sheetOptionalIndex']}_${el.imageBundleVars['flatSheetCount']}`;
    }

    if (el.imageBundleVars['pillowOptionalSize'] == 'standard-size') {
      el.image3dVarHolder["6"].fabricSection = `standard-pillowcase_${el.imageBundleVars['pillowOptionalIndex']}_${el.imageBundleVars['sPillowCount']}_${el.imageBundleVars['ePillowCount']}`;
    } else if (el.imageBundleVars['pillowOptionalSize'] == 'european-size') {
      el.image3dVarHolder["6"].fabricSection = `european-pillowcase_${el.imageBundleVars['pillowOptionalIndex']}_${el.imageBundleVars['ePillowCount']}`;
    }

    vm.construct3dImageJson();
  },
  construct3dImageJson: function() {
    var vm = this, el = vm.defaults;

    if ($('#bundle3dImageConfig').length > 0) {
      $('#bundle3dImageConfig').remove();
    }
    var finalImageConfig = Object.assign(el.imageBundleConfig, el.image3dVarHolder);

    if (el.imageBundleVars['incOptionalSheet'] == false) {
      delete finalImageConfig["5"];
    }
    if (el.imageBundleVars['incOptionalPillow'] == false) {
      delete finalImageConfig["6"];
    }
    if (el.imageBundleVars['incOptionalCandle'] == false) {
      delete finalImageConfig["7"];
    }

    var bundleJSON = JSON.stringify(finalImageConfig);
    var newScript = document.createElement("script");
    var inlineScript = document.createTextNode("'"+bundleJSON+"'");
    newScript.setAttribute("id", "bundle3dImageConfig");
    newScript.setAttribute("glasshouse-configurator-json", "");
    newScript.type = "text/javascript";
    newScript.appendChild(inlineScript);
    document.getElementById('ProductBundleBuilder3d').appendChild(newScript);

    // Start added by Glasshouse
    window.dispatchEvent(new CustomEvent('configuratorUpdate'));
    // End added by Glasshouse
  },
  pushEvent: function(eventType, eventLocation) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': eventType,
      'bundleLocation': eventLocation
    });
  }
}

doc.ready(function() {
    bundleBuilder.onReady();
  });
win.on('load', function() {
    bundleBuilder.onLoad();
});
win.resize(function() {
  bundleBuilder.onResize();
	stepResize();
});

function bundleAdded() {
	jQuery.getJSON('/cart.js', function(cart) {
		updateCartDrawer();
		var hasCandle = false;
		var declineFreecandle = getCookie('decline-freecandle');
		jQuery.each(cart.items, function(index, item) {
			if ( item.id == 11267489595439 || item.id == 11267489628207 ) {
				hasCandle = true;
			}
		});
		if ( enable_free_candles && cart.total_price >= 50000 && !hasCandle && declineFreecandle != 'true' ) {
			showFreeCandle();
		} else {
			//showCartDrawer();
			showUpsell();
		}
	});
}

var windowSize = jQuery(window).width();
function stepResize(){
	clearTimeout(this.id);
	this.id = setTimeout(function(){
		if (windowSize < 992 && jQuery(window).width() > 992 ) {
			// mobile to desktop
			var step = jQuery('.bundle-step-container .tab-c-mobile .tab-control.active').data('tab');
			if ( step == 5 ) {
				jQuery('.bundle-step-container .bundle-tab-control .tab-control[data-tab="4"]').eq(0).click();
			}
			jQuery('.bundle-step-container .bundle-tab-control .tab-control[data-tab="'+step+'"]').eq(0).click();
		}
		if (windowSize > 992 && jQuery(window).width() < 992 ) {
			// desktop to mobile
			var step = jQuery('.bundle-step-container .bundle-tab-control .tab-control.active').data('tab');
			jQuery('.bundle-step-container .tab-c-mobile .tab-control[data-tab="'+step+'"]').eq(0).click();
			$('.bundle-step-container .tab-c-mobile').slick('setPosition');
		}
		windowSize = jQuery(window).width();
	}, 500);
}